import { render, staticRenderFns } from "./ProductComboSection.vue?vue&type=template&id=98683cda"
import script from "./ProductComboSection.vue?vue&type=script&lang=js"
export * from "./ProductComboSection.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports